


















import { SubEvent } from 'inscreva-sse-models';
import $ from 'jquery';
import { Component, Vue } from 'vue-property-decorator';

import { EventUI } from '../../models/event-ui';
import { eventUIStore } from '../../store/event-ui';
import EventCardList from '../EventCardList.vue';

@Component({
  components: {
    EventCardList,
  },
})
export default class TalkComponent extends Vue {
  mounted() {
    const hash = '#talks';

    window.location.hash = '';
    $('html, body').animate(
      {
        scrollTop: $(hash).offset().top,
      },
      800,
      () => {
        window.location.hash = hash;
      },
    );
  }

  favorite(eventUI: EventUI) {
    if (!this.eventUI.event.extraFormData?.favorites) {
      this.eventUI.event.extraFormData.favorites = [];
    }

    const index = this.eventUI.event.extraFormData.favorites.findIndex((elm) => elm._id === eventUI.event._id);
    const finalIndex = index !== -1 ? index : this.eventUI.event.extraFormData.favorites.length;

    this.eventUI.event.extraFormData.favorites.splice(finalIndex, 1, {
      _id: eventUI.event._id,
      info: { name: eventUI.event.info.name, price: eventUI.event.info.price },
      parent: (eventUI.event as SubEvent).parent,
    });
  }

  get eventUI(): EventUI {
    return eventUIStore.eventUI;
  }

  get sub_events(): Array<EventUI> {
    return this.eventUI.subEventsUI;
  }
}
